import { Pagination } from '~/commonComponents';
import CustomSpinner from '../../../../commonComponents/CustomSpinner';
import { Table } from '../../../../commonComponents/Table/Table';
import { useTable } from '../hooks/useTable';
import { EmptyMessage } from './EmptyMessage';

export const CustomTable = ({
  type,
  emptyMessageType,
  data,
  renderRow,
  headerTitles,
  onRowClick,
}) => {
  const { isLoadingFirstPage, page, totalPages, onPageChange, isLoading } = useTable({
    type,
  });

  if (isLoadingFirstPage && !data?.length) {
    return <CustomSpinner size={32} />;
  }

  return (
    <div>
      {!data?.length && <EmptyMessage type={emptyMessageType ?? type} />}

      {data?.length > 0 && (
        <Table
          data={data}
          renderRow={renderRow}
          headerTitles={headerTitles}
          showActions
          onRowClick={onRowClick}
          isLoading={isLoading}
          PaginationComponent={() => (
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={onPageChange}
              maxButtons={5}
            />
          )}
        />
      )}
    </div>
  );
};
